/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { gql } from '@apollo/client';
import { GRAPHQL_ENV } from '..';

/**
 * @param {string} brand - brand name
 * @param {string} partNumber - Product Partnumber
 * @param {string} fields - fields to be return
 */

const findProductByPartNumber = (brand, partNumber, fields) => (
    gql`{ findProductByPartNumber(brand: "${brand}", environment: "${GRAPHQL_ENV}", partNumber: "${partNumber}") {
            ${fields}
            __typename
        }
    }`);

export default findProductByPartNumber;
